import { SafeError, SafePromise } from '@benzinga/safe-await';
import { Commodity } from './entities';
import { CommoditiesRestful } from './restful';
import { Session } from '@benzinga/session';
import { ExtendedListenableSubscribable } from '@benzinga/subscribable';

interface ErrorEvent {
  error?: SafeError;
  errorType: 'commodity:get_commodities_error' | 'commodity:get_commodity_error';
  type: 'error';
}

interface CommodityUpdateEvent {
  type: 'commodity:retrieving_commodity';
}

interface CommoditiesUpdateEvent {
  type: 'commodity:retrieving_commodities';
}

export type CommoditiesRequestEvent = ErrorEvent | CommodityUpdateEvent | CommoditiesUpdateEvent;

interface CommoditiesRequestFunctions {
  getCommodities: CommoditiesRequest['getCommodities'];
  getCommodity: CommoditiesRequest['getCommodity'];
}

export class CommoditiesRequest extends ExtendedListenableSubscribable<
  CommoditiesRequestEvent,
  CommoditiesRequestFunctions
> {
  private restful: CommoditiesRestful;

  constructor(session: Session) {
    super();
    this.restful = new CommoditiesRestful(session);
  }

  public getCommodities = async (category: string): SafePromise<Commodity[] | undefined> => {
    const res = await this.restful.getCommodities(category);

    if (res?.ok) {
      this.dispatch({
        type: 'commodity:retrieving_commodities',
      });
    } else if (res.err) {
      this.dispatch({
        error: res.err,
        errorType: 'commodity:get_commodities_error',
        type: 'error',
      });
    }

    return { ok: res.ok };
  };

  public getCommodity = async (symbol: string): SafePromise<Commodity | undefined> => {
    const res = await this.restful.getCommodity(symbol);

    if (res?.ok) {
      this.dispatch({
        type: 'commodity:retrieving_commodity',
      });
    } else if (res.err) {
      this.dispatch({
        error: res.err,
        errorType: 'commodity:get_commodity_error',
        type: 'error',
      });
    }

    return { ok: res.ok };
  };

  protected onSubscribe(): CommoditiesRequestFunctions {
    return {
      getCommodities: this.getCommodities,
      getCommodity: this.getCommodity,
    };
  }
}
